@if (isEditMode()) {
  <lib-health-history-item-edit
    [healthHistoryItem]="healthHistoryItem()"
    [dropdownOptions]="dropdownOptions()"
    [isEditMode]="isEditMode()"
    [isNewItem]="isNewItem()"
    [isLoading]="isLoading()"
    [deleteHealthHistoryEnabled]="deleteHealthHistoryEnabled()"
    (cancelButtonClicked)="setEditMode(false)"
    (cancelButtonClickedNewItem)="onDiscardNewItem()"
    (deleteButtonClicked)="onDeleteItem($event)"
    (saveButtonClicked)="onSaveItem($event)"
  ></lib-health-history-item-edit>
} @else {
  <lib-health-history-item-details
    [healthHistoryItem]="healthHistoryItem()"
    [editHealthHistoryEnabled]="editHealthHistoryEnabled()"
    (editButtonClicked)="setEditMode(true)"
  ></lib-health-history-item-details>
}
